export enum WebsiteFastTagError {
  DUPLICATE_SELLER_ID = "DUPLICATE_SELLER_ID",
  INVALID_FT_SETTING = "INVALID_FAST_TAG_SETTING",
  NOT_FOUND = "NOT_FOUND",
  MISSING_SELLER_ID = "MISSING_SELLER_ID",
  MISSING_SHIPPING_COST = "MISSING_SHIPPING_COST",
  REFRESH_ALREADY_IN_PROGRESS = "REFRESH_ALREADY_IN_PROGRESS",
  SHIPPING_RATE_OFFER_NOT_FOUND = "SHIPPING_RATE_OFFER_NOT_FOUND",
}
